<template>
    <div class="specialty_page">
        <layoutpage>
            <img class="banner" src="../../../static/image/yingshiyingyubanner.png" />
            <div class="content">
                <div class="screen">
                    <el-skeleton v-if="!label.length" :rows="3" animated />
                    <div v-if="label.length">
                        <el-row v-if="label.length">
                            <el-button size="small" disabled type="text">类别</el-button>
                            <span v-for="(item,index) in label" :class="`${select == item.id?'select':''}`" @click="selectLabel(item.id)" :key="index">{{ item.name }}</span>

                        </el-row>
                        <el-row v-if="Chil_data.length">
                            <el-button size="small" disabled type="text">资料</el-button>
                            <span v-for="(item,index) in Chil_data" :class="`${chil_select == item.id?'select':''}`" @click="selectGrade(index,item)" :key="index">{{ item.name }}</span>
                        </el-row>
                        <el-row v-show="Grandson_data.length">
                            <el-button size="small" disabled type="text">题型</el-button>
                            <span v-for="(item,index) in Grandson_data" :class="`${son_select == item.id?'select':''}`" @click="clickGrandson(index,item)" :key="index">{{ item.name }}</span>
                        </el-row>
                    </div>
                    
                    <el-input style="width: 400px;" placeholder="请输入材料标题" size="small" v-model="search_data.title" @change="changekeyword" clearable></el-input>
                </div>
                <el-table
                    :data="list"
                    v-loading="loading"
                    element-loading-text="Loading..."
                    :cell-style="{cursor: 'pointer'}"
                    @row-click="handleRowClick"
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="50">
                    </el-table-column>
                    <el-table-column
                    prop="title"
                    label="标题"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="type_text"
                    label="类别"
                    width="170">
                    </el-table-column>
                    <el-table-column
                    prop="click"
                    label="浏览"
                    width="100"
                    >
                    </el-table-column>   
                </el-table>
                <el-pagination
                    v-if="total_number && total_number >= search_data.pageSize"
                    style="margin-top: 20px;"
                    @size-change="changeSize"
                    @current-change="changeNumber"
                    @prev-click="prev"
                    @next-click="next"
                    :page-size="search_data.pageSize"
                    :current-page="search_data.page"
                    :total="total_number">
                </el-pagination>

            </div>
        </layoutpage>
    </div>
</template>
<script>
import Http from "../../apis/specialty";
export default {
    data(){
        return{
            select:0,
            chil_select:0,
            son_select:0,
            label:[],
            groupedArray:[],
            Chil_data:[],
            Grandson_data:[],
            list:[],
            total_number:0,

            top_label_index:0,
            chil_index:0,
            search_data:{
                page:1,
                pageSize:20,
                title:"",
                type:1,
                title:''
            },
            loading:false
        }
    },
    created(){
        this.getSpecialtyCategory()
    },

    beforeRouteLeave(to, from, next) {
        this.saveSelectedState()
        next()
    },

    methods:{
        saveSelectedState() {
            sessionStorage.setItem('specialty_select_state', JSON.stringify({
                select: this.select,
                chil_select: this.chil_select,
                son_select: this.son_select,
                top_label_index: this.top_label_index,
                chil_index: this.chil_index
            }))
        },

        restoreSelectedState() {
            const savedState = sessionStorage.getItem('specialty_select_state')
            if (savedState) {
                const state = JSON.parse(savedState)
                this.select = state.select
                this.chil_select = state.chil_select
                this.son_select = state.son_select
                this.top_label_index = state.top_label_index
                this.chil_index = state.chil_index
                return true
            }
            return false
        },

        changekeyword(){
            this.search_data.page = 1 
            this.getList()
        },
        handleRowClick(row,event){
            var _this = this
            if(!window.sessionStorage.getItem("userinfo")){

                _this.$router.push({name:'Login',query:{redirect:encodeURIComponent(window.location.href)}});
                return false
            }
            _this.$router.push({name:'SpecialtyDetail',query:{id:row.id,type:row.type}});
        },
        getList(){
            this.loading = true
            Http.Index(this.search_data).then((res) => {
                
                this.list = res.data.data
                this.total_number = res.data.total_number
                this.loading = false
            });
        },


        getSpecialtyCategory(){
            Http.getSpecialtyCategory().then((res) => {
                this.groupedArray = res.data
                this.selectTop(res.data)
            });
        },

        selectTop(data){
            var rootData = data.filter(item => item.pid === 0);
            this.label = rootData

            if (this.restoreSelectedState()) {
                // 验证恢复的 top_label_index 是否有效
                const validTop = this.label.find(item => item.id === this.top_label_index)
                if (!validTop) {
                    this.top_label_index = this.label[0].id
                }
                this.select = this.top_label_index
                this.selectChi()
            } else {
                // 默认选中第一个类别
                this.select = this.label[0].id
                this.top_label_index = this.label[0].id
                this.chil_select = 0
                this.chil_index = 0
                this.selectChi()
            }
        },
        // 二级分类
        selectChi(){
            var rootData = this.groupedArray.filter(item => item.pid === this.top_label_index);

            this.Chil_data = rootData
            var savedChil = this.Chil_data.find(item => item.id === this.chil_index)
            if (savedChil) {
                this.chil_select = savedChil.id
                this.search_data.type = savedChil.id
            } else {
                this.chil_index = this.Chil_data[0].id
                this.chil_select = this.Chil_data[0].id
                this.search_data.type = this.chil_index
            }
            this.selectGrandson()

        },

        // 三层分类
        selectGrandson(){
            var rootData = this.groupedArray.filter(item => item.pid === this.chil_index);

            if(rootData.length > 0){
                this.Grandson_data = rootData
                var savedSon = this.Grandson_data.find(item => item.id === this.son_select)
                if (savedSon) {
                    this.search_data.type = savedSon.id
                } else {
                    this.son_select = this.Grandson_data[0].id
                    this.search_data.type = this.Grandson_data[0].id
                }
            }else{
                this.Grandson_data = []
            }
            this.getList()

        },


        // 点击父级
        selectLabel(pid){

            this.chil_select = 0
            this.son_select = 0
            this.chil_index = 0
            this.search_data.page = 1
            this.top_label_index = pid
            this.select = pid
            this.selectChi()
        },

        // 点击子级
        
        selectGrade(index,value){
            this.chil_index = value.id
            this.chil_select = value.id
            this.search_data.page = 1
            this.search_data.type = value.id
            this.Grandson_data = this.groupedArray.filter(item => item.pid === value.id);
            if(this.Grandson_data.length > 0){

                this.son_select = this.Grandson_data[0].id
                this.search_data.type = this.Grandson_data[0].id
            } else {
                this.son_select = 0
            }
            this.getList()
        },

        // 点击三级分类
        clickGrandson(index,value){
            this.son_select = value.id
            this.search_data.page = 1
            this.search_data.type = value.id
            this.getList()
        },


        // 上一页
        prev(e){

            this.search_data.page = e
            this.getList()
        },

        // 下一页
        next(e){

            this.search_data.page = e
            this.getList()
        },

        // 点击页码
        changeNumber(e){

            this.search_data.page = e
            this.getList()
        },

        // 前往指定页数
        changeSize(e){

            this.search_data.page = e
            this.getList()
        }


    }
}
</script>


<style scoped>
.banner{
    width: 100%;
    height: 360px;
}
.content{
    width: 1200px;
    margin: 0 auto;
}
.content .screen >>> .is-disabled{
    height: 70px;
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    margin-right: 20px;
}
.screen{
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    text-align: left;
    border-radius: 6px;
    margin-top: 15px;
    background: #ffffff;
}
.content .screen span{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    margin-right:10px;
    margin-bottom: 10px;
}
.select{
    background: #409EFF !important;
    color: #ffffff !important;
    border-color: #409EFF !important;
}
</style>